import React, { useEffect, useState } from "react";
import { Printer } from "lucide-react";
import { getBluetoothPrinterName } from "../pages/pos/bluetoothPrinter";

interface Props {
  onClick: () => void;
}

// Sales printer status, same sign as the kitchen header: green when paired on
// this device, red when not. Click opens the printer settings to attach one.
const PrinterStatusButton: React.FC<Props> = ({ onClick }) => {
  const [printerName, setPrinterName] = useState<string | null>(() => getBluetoothPrinterName());
  useEffect(() => {
    const timer = setInterval(() => setPrinterName(getBluetoothPrinterName()), 2_000);
    return () => clearInterval(timer);
  }, []);

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={printerName ? "Printer connected" : "Printer disconnected"}
      title={
        printerName
          ? `Printer ${printerName} is paired on this device`
          : "No printer paired on this device — click to pair"
      }
      className={`h-10 px-3 rounded-lg font-outfit text-sm flex items-center gap-2 shrink-0 ${
        printerName ? "bg-green-50 text-green-700" : "bg-red-50 text-red-700"
      }`}
    >
      <span className={`w-2 h-2 rounded-full ${printerName ? "bg-green-500" : "bg-red-500"}`} />
      <Printer className="w-4 h-4" />
    </button>
  );
};

export default PrinterStatusButton;
